import { ACHIEVEMENT_NAMES } from "../achievementsConstants";
import { MOBILE_SLIDER_PAGES_IDS } from "../../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants";

export const ACHIEVEMENTS_CONGRATULATIONS = {
    [ACHIEVEMENT_NAMES.DEPOSIT_FIRST]: {
        button_primary: {
            label: 'achievements.buttons.make_more',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_FIRST]: {
        button_primary: {
            label: 'achievements.buttons.trade_more',
        },
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_FIRST_REAL]: {
        button_primary: {
            label: 'achievements.buttons.make_more',
        },
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_NEGATIVE_FIRST_REAL]: {
        button_primary: {
            label: 'achievements.buttons.no_worries',
        },
        button_secondary: {
            label: 'achievements.buttons.respawn',
            slide: MOBILE_SLIDER_PAGES_IDS.RESPAWN,
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_3]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_5]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_7]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_10]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_25]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_50]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_DEMO_5]: {
        button_primary: {
            label: 'achievements.buttons.to_real',
            handler: 'handleStartRealButtonClick',
        },
        button_secondary: {
            label: 'achievements.buttons.stay_demo',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_DEMO_10]: {
        button_primary: {
            label: 'achievements.buttons.to_real',
            handler: 'handleStartRealButtonClick',
        },
        button_secondary: {
            label: 'achievements.buttons.stay_demo',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_DEMO_20]: {
        button_primary: {
            label: 'achievements.buttons.to_real',
            handler: 'handleStartRealButtonClick',
        },
        button_secondary: {
            label: 'achievements.buttons.stay_demo',
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_DEMO_50]: {
        button_primary: {
            label: 'achievements.buttons.to_real',
            handler: 'handleStartRealButtonClick',
        },
        button_secondary: {
            label: 'achievements.buttons.stay_demo',
        }
    },
    [ACHIEVEMENT_NAMES.CONFIRM_EMAIL]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.VERIFIED]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.TRADING_DAYS_AT_ROW_7]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.TRADING_DAYS_AT_ROW_14]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.TRADING_DAYS_AT_ROW_21]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.TRADING_DAYS_AT_ROW_30]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_10]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_50]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_100]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_500]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_1000]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_5K]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
    [ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_10K]: {
        button_primary: {
            label: 'achievements.buttons.continue',
        },
        button_secondary: {
            label: 'achievements.buttons.go_achievements',
            slide: MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA,
        }
    },
}
